import { axios } from '../util'

const GET_WALLET_ENDPOINT = 'https://wallet-api.olx.com.br/wallet'

export const getWallet = () => axios.get(GET_WALLET_ENDPOINT)
